module.exports = __webpack_public_path__ + "static/media/coxinhacarnesec.ae85f903.webp";